import {
  Component,
  AfterContentInit,
  OnDestroy
} from '@angular/core';

import { ServiceLocator } from '../../ServiceLocator';
import { TranslateService } from '@ngx-translate/core';
import { HeaderActionsService } from '../common/sub-header/header-actions.service';
import { generateRandomIdentifier } from '../../ui.service';
import { WaitLoadingService } from '../common/waitLoading/wait-loading.service';
import { ConfirmationService } from 'primeng-lts/api';

declare const Quill: any;
import ImageResize from 'quill-image-resize-module';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { BaseComponent } from '../common/baseComponent/base.component';
Quill.register('modules/imageResize', ImageResize);

export class HtmlDTOModal {

  label: string;
  text: string;
  disabled = false;


  constructor(
    label: string,
    text: string,
    disabled: boolean
  ) {
    this.label = label;
    this.text = text;
    this.disabled = disabled;

  }
}


@Component({
  selector: 'html-editor',
  templateUrl: 'htmlEditor.template.html'
})
export class HtmlEditorComponent extends BaseComponent implements AfterContentInit, OnDestroy {
  public translate: TranslateService;
  public headerActionsService: HeaderActionsService;
  public waitService: WaitLoadingService;
  confirmationService: ConfirmationService;

  windowHash: string;
  loaded = false;
  label: string;
  labelDefault: string;
  originalText: string;
  context: HtmlDTOModal;

  public editorModules = { imageResize: [] };

  constructor(public ref: DynamicDialogRef, public dialogConfig: DynamicDialogConfig) {
    super();
    this.translate = ServiceLocator.injector.get(TranslateService);
    this.headerActionsService = ServiceLocator.injector.get(HeaderActionsService);
    this.waitService = ServiceLocator.injector.get(WaitLoadingService);
    this.confirmationService = ServiceLocator.injector.get(ConfirmationService);

    this.context = dialogConfig['context'];
    this.originalText = this.context.text;

    this.labelDefault = this.translate.instant('Forms.TextEditor.label');
    this.load();
  }

  load() {
    this.loaded = true;
  }

  ngAfterContentInit(): void {
    this.waitService.startWaiting();
    this.windowHash = generateRandomIdentifier();
    this.headerActionsService.clearWindowActions(this.windowHash);

    if (!this.context.disabled) {
      this.subscribe(this.headerActionsService.addWindowAction(
        'General.accept',
        'fas fa-check',
        'btn-primary',
        true, this.windowHash
      ), success => {
        this.ref.close(this.getText());
      });
    }
    this.subscribe(this.headerActionsService.addWindowAction(
      'General.cancel',
      'fas fa-times',
      'btn-outline-secondary',
      true, this.windowHash
    ), success => {
      this.confirmationService.confirm({
        message: this.translate.instant('General.discard.changes'),
        accept: () => {
          this.ref.close(this.originalText);
        }
      });
    });

    this.waitService.cancelWaiting();
  }

  ngOnDestroy() {
    this.headerActionsService.clearWindowActions(this.windowHash);
    this.dialogConfig = null;
    this.ref = null;
    super.ngOnDestroy();
  }

  getText() {
    return this.context.text;
  }

  public isLoaded() { return this.loaded; }
}
